
import { z } from 'zod';

// Define the validation schema for retention policy form
export const retentionPolicyFormSchema = z.object({
  table_name: z.string({
    required_error: "Table name is required",
  }),
  state: z.string().optional().default("all"),
  retention_years: z.number({
    required_error: "Retention period is required",
  }).min(1, "Retention period must be at least 1 year"),
  description: z.string().optional(),
  is_active: z.boolean().default(true),
});

// Define the type based on the schema
export type RetentionPolicyFormValues = z.infer<typeof retentionPolicyFormSchema>;

// Default values for the form
export const defaultFormValues: RetentionPolicyFormValues = {
  table_name: "certificates",
  state: "all",
  retention_years: 3,
  description: "",
  is_active: true,
};
